export default __webpack_public_path__ + "static/5-0c9d2b873ed8129fa746ad53d9d8a012.jpeg";